import { clear, h } from '../core/dom'
import { back } from '../core/router'
import { t } from '../i18n'
import { topbar } from './shared'

/**
 * The screen every red flag in the app routes to.
 *
 * It is deliberately plain: no animation, no branding, nothing to tap except
 * back. Someone arriving here should be reading, then closing the phone and
 * calling someone.
 *
 * No phone number is hard-coded. Emergency numbers differ by country and a
 * wrong one is worse than none — the instruction is to call the local number,
 * and to say the one sentence that changes how they are treated.
 */
export function renderSafety(root: HTMLElement): void {
  clear(root)
  const d = t().safety

  // The mode is cleared in case this was reached from 3AM mode; the warm red
  // shift makes the emergency copy harder to read than it should be.
  delete document.documentElement.dataset.mode

  root.append(
    topbar(d.title, back),
    h(
      'div',
      { class: 'stack-lg fade-in' },
      h(
        'div',
        { class: 'notice' },
        h('h3', {}, d.emergencyTitle),
        h('ul', {}, ...d.emergencyList.map((line) => h('li', {}, line))),
        h('p', { style: { marginTop: '12px' } }, d.emergencyBody),
      ),
      h(
        'div',
        { class: 'stack-sm' },
        h('h2', {}, d.taperTitle),
        h('p', { class: 'lede' }, d.taperBody),
      ),
      h(
        'div',
        { class: 'stack-sm' },
        h('h2', {}, d.crisisTitle),
        h('p', { class: 'lede' }, d.crisisBody),
      ),
      h(
        'button',
        { class: 'btn ghost block', onclick: () => back() },
        t().common.back,
      ),
    ),
  )
}
